import * as svg from "../../../assets/booking-logo-solid-circle.svg";

import {iconBuilder} from "./iconBuilder";

export const BookingCircleIcon = iconBuilder(svg, "BookingCircleIcon", "0 0 2500 2445");
